<template>
  <h5 class="card-heading" :class="getClass">
    <slot />
  </h5>
</template>

<script>
export default {
  name: 'BaseCardHeading',

  props: {
    design: { default: 'dark', type: String }
  },

  computed: {
    getClass () {
      return `text-${this.design}`
    }
  }
}
</script>
